module.exports = __webpack_public_path__ + "img/notify3.442a77da.png";